import React from "react";

interface DownloadButtonProps {
  onClick: () => void;
  className?: string;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({
  onClick,
  className = "",
}) => {
  return (
    // <button
    //   onClick={onClick}
    //   className={`bg-[#1a1f2e] hover:bg-[#2a2f3e] text-[#4B9EF9] px-4 py-2 rounded-full border border-[#4B9EF9] flex items-center space-x-2 text-sm transition-all duration-200 ${className}`}
    // >
    //   <svg
    //     className="w-4 h-4"
    //     fill="none"
    //     stroke="currentColor"
    //     viewBox="0 0 24 24"
    //   >
    //     <path
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //       strokeWidth={2}
    //       d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
    //     />
    //   </svg>
    //   <span>Download</span>
    // </button>
    <></>
  );
};

export default DownloadButton;
